import { redirect } from "react-router";
import { PAGES } from "src/configs/pages-urls";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		index: true,
		loader: () => redirect(PAGES.trackings.sub.trackings),
	},
	{
		path: PAGES.trackings.sub.trackings,
		lazy: () =>
			import("src/module--trackings/pages/trackings.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.trackings.sub.details}`,
		lazy: () =>
			import(
				"src/module--trackings/pages/tracking.page/tracking.page"
			).then(convertFrameworkRoute),
		children: [
			{
				path: PAGES.trackings.sub.return,
				lazy: () =>
					import(
						"src/module--trackings/pages/trackings-return.page"
					).then(convertFrameworkRoute),
			},
		],
	},
	{
		path: PAGES.trackings.sub.returnsOverview,
		lazy: () =>
			import(
				"src/module--trackings/pages/trackings-returns-overview.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.trackings.sub.delivery,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.TrackingsDeliveryReport,
			})),
	},
	{
		path: PAGES.trackings.sub.deliveryExceptions,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.TrackingsDeliveryExceptionsReport,
			})),
	},
	{
		path: PAGES.trackings.sub.leadTimes,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.TrackingsLeadtimesReport,
			})),
	},
	{
		path: PAGES.trackings.sub.claimsPromotion,
		lazy: () =>
			import(
				"src/module--trackings/pages/tracking.page/trackings-claims-promotion.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.trackings.sub.claims,
		lazy: () =>
			import(
				"src/module--trackings/pages/trackings-claims-report.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.trackings.sub.liveNetwork,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.TrackingsLivenetworkReport,
			})),
	},
	{
		path: PAGES.trackings.sub.communicationsInsights,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.TrackingsCommsInsightsReport,
			})),
	},
	{
		path: PAGES.trackings.sub.exceptions,
		lazy: () =>
			import("src/components/Report").then((m) => ({
				Component: m.TrackingsExceptionsReport,
			})),
	},
	{
		path: PAGES.trackings.sub.benchmarkingPromotion,
		lazy: () =>
			import(
				"src/module--trackings/pages/tracking.page/benchmarking-promotion.page"
			).then(convertFrameworkRoute),
	},
	{
		path: PAGES.trackings.sub.benchmarking,
		lazy: () =>
			import(
				"src/module--trackings/pages/trackings-benchmarking-report.page"
			).then(convertFrameworkRoute),
	},
];
